// extracted by mini-css-extract-plugin
export default {"img__container":"styles_img__container__kTpT1","img__bg":"styles_img__bg__vXXPO","img__logo":"styles_img__logo__rWnTG","img__icon":"styles_img__icon__YtFIX"};